import { BaseDataModel } from "@domain/CRM/BaseDataModel";
import { TeamStatusOption } from "@rogoag/airtable";

export class TeamMember extends BaseDataModel {
	name!: string;
	missionControlUsername!: string;
	appUserId!: number;
	password?: string;
	status!: TeamStatusOption;
	phoneNumber!: string;
}
